import { css, Theme } from '@emotion/react'
import { getColorOptions } from 'theme/utils'

export const container = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const label = (theme: Theme) => css`
  font-weight: 400;
  color: ${theme.typographyColors.typographyThree};
  margin-bottom: 10px;
`

export const tabs = css`
  margin: 24px 0;
`

export const warning = (theme: Theme) => css`
  width: 100%;
  padding: 15px;
  border-radius: 16px;
  font-weight: 400;
  margin: 24px 0 0;
  background: ${getColorOptions(theme.colors.yellow).soft};
  backdrop-filter: blur(7.5px);
  color: ${theme.colors.yellow};
  border: 1px solid ${getColorOptions(theme.colors.yellow).light};
`
